import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Typography } from 'antd';
import { ProjectDto } from '@/core';
import { EmployeeCard } from './EmployeeCard';
import { sort } from '@/utils';
import classes from './EmployeeCardsList.module.scss';

type EmployeeCardsListProps = {
  projectData: ProjectDto;
};

export const EmployeeCardsList = ({ projectData }: EmployeeCardsListProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const [editedCardsIds, setEditedCardsIds] = useState<string[]>([]);
  const employeesSortedAlphabetically = [...projectData.employees].sort((a, b) => sort(a.name, b.name));

  const handleClickEdit = (id: string) => setEditedCardsIds((prev) => [...prev, id]);
  const handleStopEditCard = (id: string) =>
    setEditedCardsIds((prev) => prev.filter((editedCardId) => editedCardId !== id));

  return (
    <div className={classes.cardsList}>
      <Row className={classes.cardsListTitle}>
        <Col span={8}>
          <Typography.Text>{t('addEmployees.name')}</Typography.Text>
        </Col>
        <Col span={8}>
          <Typography.Text>{t('addEmployees.role')}</Typography.Text>
        </Col>
        <Col span={8}>
          <Typography.Text>{t('addEmployees.department')}</Typography.Text>
        </Col>
      </Row>
      {employeesSortedAlphabetically.map((employee) => (
        <EmployeeCard
          projectData={projectData}
          key={employee.id}
          onClickMenuEdit={() => handleClickEdit(employee.id)}
          isEdit={editedCardsIds.includes(employee.id)}
          stopEditCard={() => handleStopEditCard(employee.id)}
          {...employee}
        />
      ))}
    </div>
  );
};
